import { getConditionalObject } from 'utils/data';

import { ENABLED_ROW_HOVER_SELECTOR } from './TableCDS.constants';

export const autoLayoutTableStyles = {
  '& .table': {
    tableLayout: 'auto',
  },
};

export const getCustomStyles = ({
  customStyles,
  pendingChangesTextSelector,
  isLoading,
  onRowClick,
  getRowProps,
  isDroppable,
}) => ({
  '.table-head': {
    '.table-row': {
      backgroundColor: ({ palette }) => `${palette.background.secondary} !important`,
    },
    '.table-cell': {
      padding: '12px 16px',
      fontWeight: 500,
      backgroundColor: 'inherit',
    },
  },
  '.table-body': {
    '.table-row': {
      '&:first-of-type': {
        borderTop: 'none',
      },
      ...getConditionalObject(!isLoading && (!!onRowClick || !!getRowProps), {
        [`&${ENABLED_ROW_HOVER_SELECTOR}`]: {
          cursor: 'pointer',
          backgroundColor: ({ palette }) => palette.background.hoverDefault,
        },
      }),
      ...getConditionalObject(!isLoading && isDroppable, {
        [`&${ENABLED_ROW_HOVER_SELECTOR}`]: {
          cursor: 'grab',
          backgroundColor: ({ palette }) => palette.background.hoverDefault,
        },
      }),
    },
    '.table-cell': {
      padding: '12px 16px',
    },
    '.table-cell__content_text': {
      color: ({ palette }) => palette.text.secondary,
      font: ({ typography }) => typography.regular16,
    },
    '& [data-row-added="true"], [data-row-deleted="true"]': {
      backgroundColor: ({ palette }) => palette.background.tableHighlight,
      '.table-cell__content_text, .table-cell__content_box > span': {
        color: ({ palette }) => `${palette.text.tableHighlight} !important`,
      },
    },
    '& [data-row-deleted="true"]': {
      backgroundImage: ({ palette }) =>
        `linear-gradient(to right, transparent 15px, ${palette.text.tableHighlight} 15px, ${palette.text.tableHighlight} calc(100% - 15px), transparent calc(100% - 15px))`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: '100% 2px',
    },
    '& [data-row-disabled="true"]': {
      cursor: 'default',
      '.table-cell__content_text': {
        opacity: 0.8,
      },
    },
    '& .table-row[data-rfd-dragging="true"]': {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      backgroundColor: ({ palette }) => palette.background.paper,
    },

    '& [pendingchangesactiontype="Modified"], & [data-pending-changes-action-type="Modified"]': {
      backgroundColor: ({ palette }) => palette.background.tableHighlight,
      [`> span, > ${pendingChangesTextSelector}`]: {
        color: ({ palette }) => `${palette.text.tableHighlight} !important`,
      },
    },
  },

  ...customStyles,
});
